import React, { Fragment, useEffect } from "react";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { fetchCompanyList } from "../actions/company";
import { statusRender } from "../utils/cellRenderTable";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const CompanyList = () => {
  const dispatch = useDispatch();
  const { companyList } = useSelector((state) => state.companyReducer);

  useEffect(() => {
    dispatch(fetchCompanyList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id) return null;
    return (
      <ButtonColumn
        editLink={`/company-edit/` + params.data.id}
        value={params}
      />
    );
  };

  const { t } = useTranslation();

  const columnDefs = [
    {
      headerName: t("companyList.country"),
      field: "countryName",
      filter: "agSetColumnFilter",
      flex: 1,
      minWidth: 150,
      enableRowGroup: true,
    },
    {
      headerName: t("companyList.name"),
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 200,
    },
    {
      headerName: t("companyList.status"),
      field: "status",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "INACTIVE":
            return t("companyList.inactive");
          case "ACTIVE":
            return t("companyList.active");
          default:
            return "";
        }
      },
      width: 150,
    },
    {
      headerName: t("companyList.address"),
      field: "address",
      filter: "agTextColumnFilter",
    },
    {
      headerName: t("companyList.email"),
      field: "email",
      filter: "agTextColumnFilter",
    },
    {
      headerName: t("companyList.identificationNumber"),
      field: "identificationNumber",
      filter: "agTextColumnFilter",
    },
    {
      headerName: t("companyList.phone"),
      field: "phone",
      filter: "agTextColumnFilter",
    },
    {
      headerName: t("companyList.pib"),
      field: "pib",
      filter: "agTextColumnFilter",
    },
    {
      headerName: t("companyList.createdAt"),
      field: "createdAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: t("companyList.updatedAt"),
      field: "updatedAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 80,
    },
  ];

  //breadcrumb
  const translateModule = "companies";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={companyList}
        columnDefs={columnDefs}
        buttonLink={`/company-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey={"company-list"}
      />
    </Fragment>
  );
};

export default CompanyList;
